import { Component, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { GenericOrderDetail, ImportOrderDetailInformation, ImportOrderInformation } from 'src/app/domain/models/ImportOrder';
import { BasicUser } from 'src/app/domain/models/User';
import { AssignStockComponent } from 'src/app/ui/components/assign-stock/assign-stock.component';
import { OrderUtils } from 'src/app/ui/util/order-utils';

@Component({
  selector: 'app-user-assign-stock-order',
  templateUrl: './user-assign-stock-order.component.html',
  styleUrls: ['./user-assign-stock-order.component.css'],

})
export class UserAssignStockOrderComponent implements OnInit{


    orderDetailGuid: string | undefined

    loading: boolean = false;

    importOrderInfo: ImportOrderInformation | undefined

    importOrderDetailInfo: ImportOrderDetailInformation | undefined
    detail: GenericOrderDetail | undefined

    orderType: string = 'Import'

    profile: BasicUser | undefined

    constructor(
        private _router: Router,
        private _messageService: MessageService,
        public translateService: TranslateService,
        private _activatedRoute: ActivatedRoute,
        public translate: TranslateService,
        private _palletService: PalletGateway,
        private _importOrderService: ImportOrderGateway,
        private _authService: AuthGateway,
    ){
        this._activatedRoute.params.subscribe(params => {
        this.orderDetailGuid = params['orderDetailGuid']
      })
    }

    ngOnInit(): void {

      this.profile = this._authService.getUser()
      this.loadImportOrderDetailInformation()
      this.getLabelsOrder()

    }

    loadImportOrderDetailInformation() {
      if(this.orderDetailGuid) {
        this._palletService.getByImportOrderDetailId(this.orderDetailGuid).subscribe({
          next: (v) => {
            this.importOrderDetailInfo = v
            this.detail = this.importOrderDetailInfo.importOrderDetail
            this.getImportOrder()
          },
          error: (e) => {
            console.log(e)
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: this.translate.instant('MessageService.ImportOrderDetail.SingleRetrieveError') });
          },
          complete: () => console.info('Order Detail query successfully')
        })
      }
    }

    getImportOrder() {
      if(this.detail)
      {
          this._importOrderService.getById(this.detail.importOrderId).subscribe({
          next : (v) => {
            this.importOrderInfo = v
          },
          error: () => {
            this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: 'Failed retrieving sale program'});
          }
          })
      }
    }

    getImageUrl(url?: string): string {
    if(url){
      //return environment.apiUrl + url
      return url
    }else{
      return  ''
    }

  }

  padWithLeadingZeros(id: number): string {
    return OrderUtils.padWithLeadingZeros(id)
  }

  getLabelsOrder() {
    if(this.profile?.profileType == 'Exporter') {
      this.orderType = 'Export'
    }
  }

  AfterAssignOrder()
  {
    this.loadImportOrderDetailInformation();
  }


}
